const DOMReady = function (callback) {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    callback();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', callback());
  } else if (document.attachEvent) {
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState != 'loading') {
        callback();
      }
    });
  }
};
DOMReady(function () {
  // Accordion toggle
  const elements = document.querySelectorAll('.mobile_menu_dropclick');

  elements.forEach((element) => {
    const parent = element.closest('.mobile_menu_li');

    element.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (parent.classList.contains('mobile_menu_active')) {
        parent.classList.remove('mobile_menu_active');
      } else {
        parent.classList.add('mobile_menu_active');
      }
    });
  });

  // Intercept tab clicks at capture phase to prevent header-drawer from closing
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.pottd-tab');
    if (!tab) return;
    e.stopImmediatePropagation();
    var target = tab.dataset.tab;
    document.querySelectorAll('.pottd-tab').forEach(function (t) {
      t.classList.toggle('pottd-tab--active', t.dataset.tab === target);
    });
    document.querySelectorAll('.pottd-tab-panel').forEach(function (panel) {
      panel.classList.toggle('pottd-tab-panel--hidden', panel.dataset.panel !== target);
    });
  }, true);

  // Close button inside drawer panel.
  // This has to go through the custom element's closeMenuDrawer(): that is the
  // only path that releases the body scroll lock (overflow-hidden-*) and the
  // focus trap. Just dropping the `open` attribute left the page unscrollable
  // and unclickable until a reload.
  // Capture phase + stopImmediatePropagation also keeps MenuDrawer.bindEvents'
  // generic button handler (closeSubmenu) from handling this button instead.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.pottd-drawer-close');
      if (!btn) return;
      e.stopImmediatePropagation();
      e.preventDefault();

      var drawer = btn.closest('header-drawer, menu-drawer');
      var summary = drawer && drawer.querySelector('summary');

      // HeaderDrawer.closeMenuDrawer returns early unless it gets elementToFocus.
      if (drawer && typeof drawer.closeMenuDrawer === 'function' && summary) {
        try {
          drawer.closeMenuDrawer(e, summary);
        } catch (err) {
          // Fall through to the forced reset below either way.
        }
      }

      // Force the visual/structural reset regardless of what the call above
      // did. This is what actually fixes the drawer staying on screen after
      // close: closeMenuDrawer's own closeAnimation() waits ~400ms before
      // dropping the `open` attribute, and any exception along that path
      // (this drawer extends a class with a few unguarded property accesses)
      // used to abort before ever reaching it.
      var container = drawer || btn.closest('details');
      if (container) {
        container.querySelectorAll('details[open]').forEach(function (details) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        var outerDetails = container.tagName === 'DETAILS' ? container : container.querySelector('details');
        if (outerDetails) {
          outerDetails.removeAttribute('open');
          outerDetails.classList.remove('menu-opening');
        }
      }
      document.querySelector('.section-header')?.classList.remove('menu-open');
      document.body.classList.remove(
        'overflow-hidden-mobile',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop'
      );

      // Also force this regardless of whether the try block above succeeded:
      // .header__icon--menu[aria-expanded='true']::before (base.css) is a
      // full-height translucent backdrop keyed purely off this attribute, not
      // off `open`/menu-opening. Left stuck at "true", it stays visible over
      // the page after the drawer panel itself has already closed.
      if (summary) summary.setAttribute('aria-expanded', 'false');
    },
    true
  );
});
